export default __webpack_public_path__ + "static/media/anubhab.667e4f14.jpeg";